import type { HighlightItem, HighlightItemKind } from "@/features/experience-shared/highlights-v2/types/highlight-item";

/**
 * Rebuilds the flat `HighlightItem[]` with one kind's slice replaced, leaving the other
 * kind's items untouched and preserving the persisted premade-before-custom order.
 *
 * This is the single point of contact between the two kind-scoped composables
 * (`usePremadeList` / `useCustomList`): they share one array but each only ever rewrites
 * its own slice through this helper, so neither needs to know about the other's items.
 */
export function replaceSlice(
  items: HighlightItem[],
  kind: HighlightItemKind,
  nextSlice: HighlightItem[]
): HighlightItem[] {
  const other = items.filter((item) => item.kind !== kind);
  return kind === "premade" ? [...nextSlice, ...other] : [...other, ...nextSlice];
}
